import { render, staticRenderFns } from "./mailConfigModal.vue?vue&type=template&id=37874925&scoped=true"
import script from "./mailConfigModal.vue?vue&type=script&lang=js"
export * from "./mailConfigModal.vue?vue&type=script&lang=js"
import style0 from "./mailConfigModal.vue?vue&type=style&index=0&id=37874925&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37874925",
  null
  
)

export default component.exports